import Api from '@api/decoration'
import { isSiDaProperty } from '@merchant-backend/util'
import { getMerchantInfo } from '@util'
import { observable } from 'mobx'

class Store {
  @observable commentTagList = []
  @observable currentCommentTag = '0' // 全部
  @observable comment = {}
  @observable totalAll = 0

  changeTag = id => {
    this.currentCommentTag = id
    this.getCommentList(false)
  }

  /**
   * 用户评价
   */
  getCommentTagList = async () => {
    const {
      data: { list }
    } = await Api.commentTag({ merchant_id: getMerchantInfo().id })

    this.commentTagList = list || []
  }

  getCommentList = async (setTotalAll = true) => {
    const params = {
      merchant_id: getMerchantInfo().id,
      tag_id: this.currentCommentTag,
      per_page: 1
    }

    if (isSiDaProperty()) {
      params.per_page = 2
    }

    const { data } = await Api.commentList(params)

    this.comment = data || {}

    if (setTotalAll) {
      this.totalAll = this.comment.total_count
    }
  }
}

export default Store
